/*
  Bahimi recently-viewed (handoff §10 A–J, item H). localStorage 'bahimi_recent'.
  - On a product page, a <script type="application/json" data-bh-recent-product>
    payload records {handle,title,url,image,price}.
  - Any page with [data-bh-recent] + [data-bh-recent-row] renders the strip
    (excluding the current product), newest first, max 5 shown / 8 stored.
*/
(function () {
  if (window.BahimiRecent) return;
  var KEY = 'bahimi_recent';

  function read() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(a) ? a : [];
    } catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 8))); } catch (e) {}
  }
  function record(item) {
    if (!item || !item.handle) return;
    var a = read().filter(function (x) { return x.handle !== item.handle; });
    a.unshift(item);
    write(a);
  }

  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function currentPayload() {
    var node = document.querySelector('[data-bh-recent-product]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function renderStrip() {
    var strip = document.querySelector('[data-bh-recent]');
    var row = document.querySelector('[data-bh-recent-row]');
    if (!strip || !row) return;
    var cur = currentPayload();
    var curHandle = cur ? cur.handle : null;
    var items = read().filter(function (x) { return x.handle !== curHandle; }).slice(0, 5);
    if (!items.length) { strip.hidden = true; return; }
    row.innerHTML = items.map(function (it) {
      var img = it.image ? '<img src="' + escHtml(it.image) + '" alt="" loading="lazy" width="300" height="400" style="width:100%;height:100%;object-fit:cover;display:block;">' : '';
      var price = it.price ? '<span class="bh-recent__price">' + escHtml(it.price) + '</span>' : '';
      return '<li class="bh-recent__card">' +
        '<a class="bh-recent__media" href="' + escHtml(it.url) + '" style="display:block;aspect-ratio:3/4;overflow:hidden;">' + img + '</a>' +
        '<a class="bh-recent__name" href="' + escHtml(it.url) + '">' + escHtml(it.title) + '</a>' +
        price +
        '</li>';
    }).join('');
    strip.hidden = false;
  }

  function init() {
    var cur = currentPayload();
    if (cur) record(cur);
    renderStrip();
  }

  window.BahimiRecent = { record: record, read: read };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
